import { getCookie } from '../bv/cookies';

export const loggedIn = () => !!getCookie('_vc_l') && !(getCookie('_vc_l') === 'false');
export const accountNumber = () => getCookie('_vc_l');
export const accountId = () => getCookie('_vc_i');
export const countryCode = () => getCookie('country_code');
export const originId = () => window.VCSTATE.ORIGIN_ID;
